import React, { useEffect } from "react";
import logoTransparent from "../Assets/images/logo-transparent.png";
import { FaEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { useState } from "react";
import { useRef } from "react";
import { useAppContext } from "../Context/AppContext.jsx";
import { callLogin } from "../Components/Functions/callLogin.jsx";
import { AiOutlineLoading } from "react-icons/ai";
import sleep from "../Components/Functions/sleep.jsx";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { CgDanger } from "react-icons/cg";
const Login = () => {
  const { login, token } = useAppContext();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const passwordRef = useRef();

  const [userInfo, setUserInfo] = useState({
    username: "",
    password: "",
  });

  const changePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  useEffect(() => {
    if (passwordVisible) {
      passwordRef.current.type = "text";
    } else {
      passwordRef.current.type = "password";
    }
  }, [passwordVisible]);

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, []);

  const handleChange = (e) => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      setLoading(true);
      let urlLogin =
         process.env.REACT_APP_URL + "api/login" +
        "?username=" +
        userInfo.username +
        "&password=" +
        userInfo.password;
      let method = "POST";
      const inputUser = userInfo;

      const response = await callLogin({
        user: inputUser,
        request: { url: urlLogin, method: method },
      });

      if (response.success) {
        login(response.token, response.user);
        await sleep(1000);

        toast.success("Sesión iniciada con exito.");
        navigate("/dashboard");
      } else {
        /// fallo de credenciales
        await sleep(2000);
        throw new Error("Credenciales incorrectas");
      }
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white w-screen h-screen flex-cols md:flex">
      <div className="md:w-[80%] md:grow md:h-[100%] flex justify-center items-center h-[50%]">
        <img
          src={logoTransparent}
          alt=""
          className="md:w-[400px] md:h[300px] w-[70%]"
        />
      </div>
      <div className="md:w-[20%] md:max-w-[400px] md:min-w-[300px] md:h-[100%] md:shadow-md md:shadow-mariposa  flex flex-col items-center justify-center p-2 gap-y-4">
        <div className="flex flex-col w-[80%] gap-y-5">
          <h1 className="text-[19px] font-[600] text-slate-800 mb-[50px] place-self-center">
            Iniciar Sesión
          </h1>

          <div className="flex flex-col gap-y-[1px]">
            <label
              htmlFor="user"
              className="text-[12px] font-[600] text-[#777] w-[100%] block"
            >
              Usuario
            </label>
            <input
              type="text"
              name="username"
              id="user"
              required
              className="p-2 text-[14px] border border-slate-300 rounded-sm"
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col gap-y-[1px] w-[100%]">
            <label
              htmlFor="password"
              className="text-[12px] font-[600] text-[#777] w-[100%] block"
            >
              Contraseña
            </label>

            <div className="relative">
              <input
                ref={passwordRef}
                type="password"
                name="password"
                id="pass"
                required
                className="p-2 text-[14px] border border-slate-300 rounded-sm w-[100%] flex"
                onChange={handleChange}
              />
              <button
                onClick={changePasswordVisibility}
                className="absolute right-1 top-1/2 transform -translate-y-1/2 text-slate-400 text-[12px] cursor-pointer"
              >
                <FaEyeSlash
                  className={`absolute right-1 top-1/2 transform -translate-y-1/2 text-slate-400 text-[20px] cursor-pointer ${!passwordVisible ? "hidden" : ""}`}
                />
                <FaRegEye
                  className={`absolute right-1 top-1/2 transform -translate-y-1/2 text-slate-400 text-[20px] cursor-pointer ${!passwordVisible ? "" : "hidden"}`}
                />
              </button>
            </div>
          </div>

          <button
            className="relative bg-mariposa p-2 rounded-sm text-white text-[14px] font-[500] font-Roboto hover:text-[16px] transition-all flex items-center justify-center"
            onClick={handleSubmit}
          >
            {loading ? (
              <div className="flex">
                <AiOutlineLoading className="animate-spin text-white text-[16px] font-[800] mr-2 mt-1" />
                <span className="font-Roboto text-white text-[16px]">
                  Iniciando sesión...
                </span>
              </div>
            ) : (
              <span>Iniciar Sesión</span>
            )}
          </button>
          <div
            className={
              errorMessage
                ? `text-pink-600 text-[12px] font-bold font-Roboto`
                : `hidden`
            }
          >
            <CgDanger className="mr-1 inline" />
            {errorMessage}
          </div>
          <button className="text-sky-500 text-[12px]">
            Olvidé mi contraseña
          </button>
        </div>
      </div>
    </div>
  );
};
export default Login;
